import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

import { scenariosAdapter } from '../adapters/scenariosAdapter'
import { planningShiftsSelectors } from './planningShiftsSelectors'

export const scenariosSelectors = scenariosAdapter.getSelectors<RootState>(
  (state) => state.scenarios,
)

// Custom selectors that merge scenarios with their shifts
export const selectAllScenariosWithShifts = createSelector(
  [(state: RootState) => state.userInterface.activeGroupId, scenariosSelectors.selectAll, planningShiftsSelectors.selectAll],
  (activeGroupId, scenarios, shifts) => {
    return scenarios
      .filter(scenario => scenario.groupId === activeGroupId)
      .sort((a, b) => b.displayOrder - a.displayOrder)
      .map(scenario => ({
        ...scenario,
        shifts: shifts.filter(shift => shift.scenarioId === scenario.id),
      }))
  },
)

// Custom selector that get a scenario by id and merge it with its shifts
export const selectScenarioWithShiftsById = createSelector(
  [scenariosSelectors.selectById, planningShiftsSelectors.selectAll, (_, scenarioId) => scenarioId],
  (scenario, shifts, scenarioId) => {
    if (!scenario) return undefined

    return {
      ...scenario,
      shifts: shifts.filter(shift => shift.scenarioId == scenarioId),
    }
  },
)

